import { User, Office } from '../types'

interface UseIsSalesforceLiveChatAvailableProps {
  currentUser: User | null
  currentOffice: Office | null
}

/**
 * A custom React hook that provides a boolean indicating if Salesforce LiveChat
 * should be available to the current user in the current office.
 *
 * This hook now accepts user, office as arguments from the consuming application.
 *
 * Conditions for availability:
 * - User is authenticated and verified.
 *
 * @param props - Object containing current user, and office
 * @returns boolean - True if LiveChat should be available, false otherwise.
 */
export const useIsSalesforceLiveChatAvailable = ({
  currentUser,
  currentOffice,
}: UseIsSalesforceLiveChatAvailableProps): boolean => {
  const isAvailable = !!currentUser && !!currentOffice

  return isAvailable
}
